import React, {useState}  from 'react';
import styles from './DecisionModal.module.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Spinner from './Spinner';

const DecisionModal = ({ show, onHide, onConfirm, title, spin, actionConcluded }) => {
    const [buttonsDisabled, setButtonsDisabled] = useState(false);

    if (!show){
        if(buttonsDisabled){
            setButtonsDisabled(false);
        }
        return null;
    } 

    const handleConfirmClick = () => {
        // Disable the buttons when the "Yes" button is clicked
        setButtonsDisabled(true);

        // Trigger the onConfirm function
        onConfirm();
    };

    return (
        <div className={styles.modal} style={{ display: 'block' }}>
            <div className={styles.modal_dialog}>
                <button className={`${styles.close} ${styles.button_close}`} onClick={onHide}>&times;</button>
                <div className={styles.modal_header}>
                    <h5 className={styles.modal_title}>{title}</h5>
                </div>
                <div className={styles.modal_body}>
                    Are you sure you want to proceed?
                </div>
                <div className={styles.modal_footer}>
                    <button 
                        className={`${styles.secondary} ${styles.button}`} 
                        onClick={onHide} 
                        disabled={buttonsDisabled} // Disable the "No" button when the "Yes" button is clicked
                    >
                        No
                    </button>
                    {spin && (
                        <Spinner color="#7572c7" size='15px' thick='5px' />
                    )}
                    {actionConcluded && (
                        <div className={styles.confirmationMessage}>
                            <i className="bi bi-check-circle-fill"> </i> 
                            <span style={{ paddingLeft: '5px', fontSize: '12pt' }}>Done!</span>
                        </div>
                    )}
                    <button 
                        className={`${styles.primary} ${styles.button}`} 
                        onClick={handleConfirmClick} 
                        disabled={buttonsDisabled} // Disable the "Yes" button when clicked
                    >
                        Yes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DecisionModal;